export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AdGroup: 'adGroup',
  AssetGroup: 'assetGroup',
  CampaignLocation: 'campaignLocation',
  CampaignRadius: 'campaignRadius',
  CampaignNegativeLocation: 'campaignNegativeLocation',
  CampaignLocationIntent: 'campaignLocationIntent',
  CampaignDayTimeCriterion: 'campaignDayTimeCriterion',
  CampaignNegativeWebpage: 'campaignNegativeWebpage',
  AudienceGroupAssetGroupAssociation: 'audienceGroupAssetGroupAssociation',
  BrandListAssociation: 'brandListAssociation',
};
